import { render, staticRenderFns } from "./NotSatisfiedBoxCard.vue?vue&type=template&id=d5a012aa&scoped=true&"
import script from "./NotSatisfiedBoxCard.vue?vue&type=script&lang=js&"
export * from "./NotSatisfiedBoxCard.vue?vue&type=script&lang=js&"
import style0 from "./NotSatisfiedBoxCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotSatisfiedBoxCard.vue?vue&type=style&index=1&id=d5a012aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a012aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5a012aa')) {
      api.createRecord('d5a012aa', component.options)
    } else {
      api.reload('d5a012aa', component.options)
    }
    module.hot.accept("./NotSatisfiedBoxCard.vue?vue&type=template&id=d5a012aa&scoped=true&", function () {
      api.rerender('d5a012aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardList/NotSatisfiedBoxCard.vue"
export default component.exports